// Global access to all functions and variables in name space
// @namespace sampleNamespace
if (typeof tinCannyReporting === 'undefined') {
	// the namespace is not defined
	var tinCannyReporting = {};
}

(function ($) { // Self Executing function with $ alias for jQuery

	/* Initialization  similar to include once but since all js is loaded by the browser automatically the all
	 * we have to do is call our functions to initialize them, his is only run in the main configuration file
	 */
	$(document).ready(function () {

		if ($('#uotc-question-report').length) {
			tinCannyReporting.questionAnalysisReport.constructor();
		}

		if ( $( '#uotc-question-report-selections' ).length ) {

			tinCannyReporting.questionAnalysisFilters.init();
		}

	});

	tinCannyReporting.questionAnalysisReport = {
		uoTable: null,

		constructor: function () {
			this.createTable();
		},

		createTable: function (data) {

			// Check if localized data exists
			if (typeof uoQuestionAnalysisReportSetup === 'undefined') {
				console.error('uoQuestionAnalysisReportSetup is not defined');
				return;
			}

			// Generate filename for exports
			var getFileName = function() {
				var filenameParts = [document.title];
				var $filter = document.getElementById('uotc-question-report-group');
				
				if ($filter && $filter.value && $filter.value != '0') {
					var selectedOption = $filter.querySelector('option[value="' + $filter.value + '"]');
					if (selectedOption) {
						filenameParts.push(selectedOption.innerText.trim());
					}
				}
				
				return filenameParts.join(' - ');
			};

			var tableVars = {
				dom: '<"reporting-datatable"<"reporting-datatable__top"<"reporting-datatable__search"f><"reporting-datatable-top__middle"><"reporting-datatable__buttons"B>><"reporting-datatable__table"t><"reporting-datatable__bottom"<"reporting-datatable__bottom-left"<"reporting-datatable__bottom-left-info"i><"reporting-datatable__bottom-left-info"l>><"reporting-datatable__bottom-right"p><"reporting-datatable__bottom-notice">>>',
				aLengthMenu: [
					[15, 30, 60, -1],
					[15, 30, 60, 'All']
				],
				order: [],
				iDisplayLength: 30,
				responsive: true,
				searching: true,
				columnDefs: [
					{
						targets: '_all',
						orderable: true,
						searchable: true,
						defaultContent: '' // Prevent error for missing data in dynamic columns
					},
				],
				buttons: [
					{
						extend: 'csvHtml5',
						text: 'CSV',
						filename: getFileName
					},
					{
						extend: 'excelHtml5',
						text: 'Excel',
						filename: getFileName
					}
				],
			};

			if (null !== this.uoTable) {
				this.uoTable.destroy();
			}

			// Build language config from localized data
			var i18n = uoQuestionAnalysisReportSetup.i18n || {};
			tableVars.language = {
				emptyTable: i18n.emptyTable || 'No data available in table',
				info: i18n.info || 'Showing _START_ to _END_ of _TOTAL_ entries',
				infoEmpty: i18n.infoEmpty || 'Showing 0 to 0 of 0 entries',
				infoFiltered: i18n.infoFiltered || '(filtered from _MAX_ total entries)',
				lengthMenu: i18n.lengthMenu || 'Show _MENU_ entries',
				loadingRecords: i18n.loadingRecords || 'Loading...',
				processing: i18n.processing || 'Processing...',
				search: '',
				searchPlaceholder: i18n.searchPlaceholder || 'Search...',
				zeroRecords: i18n.zeroRecords || 'No matching records found',
				paginate: {
					first: (i18n.paginate && i18n.paginate.first) || 'First',
					last: (i18n.paginate && i18n.paginate.last) || 'Last',
					next: (i18n.paginate && i18n.paginate.next) || 'Next',
					previous: (i18n.paginate && i18n.paginate.previous) || 'Previous'
				},
				aria: {
					sortAscending: (i18n.aria && i18n.aria.sortAscending) || ': activate to sort column ascending',
					sortDescending: (i18n.aria && i18n.aria.sortDescending) || ': activate to sort column descending'
				}
			};

			this.uoTable = jQuery('#uotc-question-report').DataTable(tableVars);

			$('.uotc-question-report__btn.uotc-question-report__btn--csv').on('click', function () {
				$('#uotc-user-report-container--hidden .buttons-csv').click();
			});

			$('.uotc-question-report__btn.uotc-question-report__btn--pdf').on('click', function () {
				$('#uotc-user-report-container--hidden .buttons-pdf').click();
			});
		}
	};

	tinCannyReporting.questionAnalysisFilters = {
		init: function() {

			// Loading on submit
			this.loadingOnSubmit();

			// Add select2 to fields
			this.select2Dropdowns();

			// Handle quiz selection validation
			this.quizSelectionValidation();

		},

		quizSelectionValidation: function() {
			const $quizSelect = $( '#uotc-question-report-group' );
			const $submitBtn = this.getForm().find( 'input[type="submit"]' );

			// Function to update button state
			const updateButtonState = function() {
				const isQuizSelected = $quizSelect.val() && $quizSelect.val() !== '0';
				$submitBtn.prop( 'disabled', !isQuizSelected );
			};

			// Set initial state
			updateButtonState();

			// Update on quiz dropdown change
			$quizSelect.on( 'change', updateButtonState );
		},

		loadingOnSubmit: function(){
			// Instance reference
			let _this = this;

			// Get selects
			const $selects = this.getForm().find( 'select' );

			// Submit when a field changes
			this.getForm().on( 'submit', function( e ) {

				// Prevent submit if no quiz is selected
				const $quizSelect = $( '#uotc-question-report-group' );
				if ( !$quizSelect.val() || $quizSelect.val() === '0' ) {
					e.preventDefault();
					return false;
				}

				// Add loading class
				_this.getForm().addClass( 'uotc-question-report-selections-form--loading' );

				// Disable selects
				$selects.prop( 'readonly', true );

			} );
		},

		select2Dropdowns: function(){
			// Get selects
			const $selects = this.getForm().find( 'select' );

			// Init select2
			$selects.each( function( i, select ){
				try {
					const $select = $( select );

					// Create the options
					const options = {};

					// Add placeholder
					const placeholder = $select.data( 'placeholder' );
					if ( placeholder ) {
						options.placeholder = placeholder;
					}

					// Init select 2
					$select.select2( options );
				} catch ( e ) {
					console.log( e );
				}
			} );

		},

		getForm: function() {
			return $( '#uotc-question-report-selections > form' );
		}
	}
})(jQuery);
